import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("内容预览 ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "content" }, null, -1)
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '24px', margin: 0, minHeight: '280px' } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createVNode(_component_a_form, {
                      layout: "inline",
                      model: _ctx.param
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleQuery())),
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add())),
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  (_ctx.level1.length>0)
                    ? (_openBlock(), _createBlock(_component_a_table, {
                        key: 0,
                        columns: _ctx.columns,
                        "data-source": _ctx.level1,
                        "row-key": record => record.id,
                        loading: _ctx.loading,
                        pagination: false,
                        size: "small",
                        defaultExpandAllRows: true
                      }, {
                        name: _withCtx(({ text,record }) => [
                          _createTextVNode(_toDisplayString(record.sort) + " " + _toDisplayString(text), 1)
                        ]),
                        action: _withCtx(({ text,record }) => [
                          _createVNode(_component_a_space, { size: "small" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: ($event: any) => (_ctx.edit(record)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_a_popconfirm, {
                                title: "删除后不可恢复，确认删除？",
                                "ok-text": "是",
                                "cancel-text": "否",
                                onConfirm: ($event: any) => (_ctx.handleDelete(record.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    danger: "",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onConfirm"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "row-key", "loading"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 16 }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createVNode(_component_a_form, {
                      layout: "inline",
                      model: _ctx.param
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSave()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _createVNode(_component_a_form, {
                    model: _ctx.doc,
                    layout: "vertical"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.doc.name,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.doc.name) = $event)),
                            placeholder: "名称"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tree_select, {
                            value: _ctx.doc.parent,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.doc.parent) = $event)),
                            style: {"width":"100%"},
                            "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
                            "tree-data": _ctx.treeSelectData,
                            placeholder: "请选择父文档",
                            "tree-default-expand-all": "",
                            replaceFields: {title:'name', key:'id', value:'id'}
                          }, null, 8, ["value", "tree-data"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.doc.sort,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.doc.sort) = $event)),
                            placeholder: "顺序"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handlePreviewContent()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_EyeOutlined),
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_drawer, {
            width: "900",
            placement: "right",
            closable: false,
            visible: _ctx.drawerVisible,
            onClose: _ctx.onDrawerClose
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "wangeditor",
                innerHTML: _ctx.previewHtml
              }, null, 8, _hoisted_8)
            ]),
            _: 1
          }, 8, ["visible", "onClose"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}